import Footer from "../../components/common/footer";
import HeaderTwo from "../../components/common/headerTwo";
import { Helmet } from "react-helmet";
import Offer1KarczowanieDrzew from "../../components/offer/1karczowanieDrzew";

function K1MulczerLesny() {
  return (
    <>
      <Helmet>
        <title>Karczowanie działek pod budowę i usuwanie korzeni | Gdańsk, Gdynia, Kartuzy</title>
        <meta name="title" content="Karczowanie działek pod budowę i usuwanie korzeni | Gdańsk, Gdynia, Kartuzy" />
        <meta
          name="description"
          content="Kompleksowe karczowanie działek, usuwanie krzewów, korzeni i pni pod nowe inwestycje budowlane. Pracujemy na terenie Gdańska, Gdyni, Wejherowa, Kartuz i Kaszub."
          key="desc"
        />
        <meta
          property="og:title"
          content="Karczowanie działek pod budowę i usuwanie korzeni | Gdańsk, Gdynia, Kartuzy"
        />
        <meta
          property="og:description"
          content="Kompleksowe karczowanie działek, usuwanie krzewów, korzeni i pni pod nowe inwestycje budowlane. Pracujemy na terenie Gdańska, Gdyni, Wejherowa, Kartuz i Kaszub."
        />
        <meta
          property="og:image"
          content="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/logo-white-10.55.05.png"
        />
      </Helmet>
      <HeaderTwo />
      <main className="relative z-40">
        <Offer1KarczowanieDrzew />
      </main>
      <Footer />
    </>
  );
}
export default K1MulczerLesny;
